(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot"] && !Shopify.designMode) return;
  try {
    
  // Reinitialize Trustpilot widgets when customizer updates
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.classList.contains('trustpilot-section') || event.target.querySelector('.trustpilot-section')) {
        setTimeout(() => {
          if (window.Trustpilot) {
            const widgets = event.target.querySelectorAll('.trustpilot-widget');
            widgets.forEach(widget => {
              window.Trustpilot.loadFromElement(widget, true);
            });
          }
        }, 500); // Increased timeout for carousel
      }
    });

    document.addEventListener('shopify:block:select', function(event) {
      if (event.target.querySelector('.trustpilot-widget')) {
        setTimeout(() => {
          if (window.Trustpilot) {
            const widget = event.target.querySelector('.trustpilot-widget');
            if (widget) {
              window.Trustpilot.loadFromElement(widget, true);
            }
          }
        }, 500); // Increased timeout for carousel
      }
    });
  }

  // Force reload all Trustpilot widgets on page load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      if (window.Trustpilot) {
        const allWidgets = document.querySelectorAll('.trustpilot-widget');
        allWidgets.forEach(widget => {
          window.Trustpilot.loadFromElement(widget, true);
        });
      }
    }, 1000); // Wait for Trustpilot script to fully load
  });

  } catch(e) { console.error(e); }
})();
})();
